import { MultiRadioTable } from "../../../components/MultiRadioTable";
import { useTranslation } from "react-i18next";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();

  const questions = [
    "Si denuncio un caso de hostigamiento o acoso sexual laboral, me podría generar consecuencias en mi trabajo.",
    "Un caso de acoso en el que se acusa a una persona que pertenece a la plana gerencial no sería investigado adecuadamente en mi trabajo.",
    "El hostigamiento o acoso sexual no es tolerado en mi ambiente laboral.",
    "Las personas que hostigan o acosan a otras/os normalmente se salen con la suya (por ejemplo, no son sancionadas).",
    "Se están tomando acciones efectivas contra el hostigamiento o acoso sexual en mi trabajo.",
    "Las personas que ocupan cargos directivos en mi organización tienen una postura expresa contra el acoso.",
  ];

  const questionIds = [
    "CON_001",
    "CON_003",
    "CON_004",
    "CON_005",
    "CON_006",
    "CON_007",
  ];

  return (
    <MultiRadioTable
      form={form}
      label={t("organizationTrust.label")}
      options={[
        { label: t("agreementOptions.0"), value: "Totalmente de acuerdo." },
        { label: t("agreementOptions.1"), value: "De acuerdo." },
        { label: t("agreementOptions.2"), value: "En desacuerdo." },
        { label: t("agreementOptions.3"), value: "Totalmente en desacuerdo." }
      ]}
      questions={questions}
      questionIds={questionIds}
    />
  );
};

export default Component;
